import { useState, useEffect, useCallback } from 'react';
import { Fetcher } from '@this/src/util';

export const SHORT_DISTANCE_MODE = {
  ALL: 'all',
  LIMITED: 'limited'
} as const;

export type ShortDistanceMode = typeof SHORT_DISTANCE_MODE[keyof typeof SHORT_DISTANCE_MODE];

interface UseShortDistanceReturn {
  shortDistance: boolean;
  shortDistanceMode: ShortDistanceMode;
  isLoading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
}

export const useShortDistance = (): UseShortDistanceReturn => {
  const [shortDistance, setShortDistance] = useState<boolean>(false);
  const [shortDistanceMode, setShortDistanceMode] = useState<ShortDistanceMode>(SHORT_DISTANCE_MODE.ALL);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const fetchShortDistance = useCallback(async () => {
    try {
      setIsLoading(true);
      setError(null);

      const response = await Fetcher.get<{
        shortDistance: boolean;
        mode: ShortDistanceMode;
      }>('/shortdistance.json');

      setShortDistance(response.shortDistance);
      setShortDistanceMode(response.mode);
    } catch (err) {
      setError('通信環境が不安定です。\n時間をおいてもう一度お試しください。');
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchShortDistance();
  }, [fetchShortDistance]);

  return {
    shortDistance,
    shortDistanceMode,
    isLoading,
    error,
    refetch: fetchShortDistance
  };
};
